import React, { useState, useEffect } from "react";
import "./Dec2025_Womens_T20EventSelect.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function SportSelect() {
  const [sport, setSport] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [teamCategory, setTeamCategory] = useState("");
  const [teamType, setTeamType] = useState("");
  const navigate = useNavigate();


  // 🔹 Common Navigation Function
  const handleNavigation = (teamType, userId) => {
    if (teamType === "Team") {
      navigate(`/cricket-form/${userId}`);
    } else {
      navigate(`/cricket-individual-form/${userId}`);
    }
  };


  const handleProceed = async () => {
    // 🔹 Validate - Team Type
    if (!teamType) {
      return Swal.fire({
        icon: "info",
        title: "Team Type Missing",
        text: "Please select Individual or Team!",
        timer: 3000,
        showConfirmButton: false,
      });
    }

    // 🔹 Validate - Terms
    if (!accepted) {
      return Swal.fire({
        icon: "warning",
        title: "Terms & Conditions",
        text: "You must accept the Terms & Conditions to proceed!",
        timer: 3000,
        showConfirmButton: false,
      });
    }

    try {
      // ⏳ Loading state
      Swal.fire({
        title: "⏳ Submitting your registration...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await fetch(
        "https://node.aattumtpl.com/api/event/womens-t20/2025/register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sport: "Cricket",
            genderCategory: "Women",
            teamType,
            termsAccepted: accepted,
          }),
        }
      );

      const text = await res.text();
      let data;

      // 🔍 Safe JSON parse
      try {
        data = JSON.parse(text);
      } catch (err) {
        console.error("Server returned invalid JSON:", text);
        Swal.close();
        return Swal.fire({
          icon: "error",
          title: "⚠️ Invalid Server Response",
          text: "The server returned an unexpected response.",
        });
      }

      Swal.close();

      // 🎯 Success
      if (res.ok && data.success) {
        const userId = data.userId;

        // 💾 Save to Local Storage
        localStorage.setItem("userId", userId);

        // 🎉 Success Alert
        Swal.fire({
          icon: "success",
          title: "🎉 Registration Successful!",
          html: `
          <p>Your User ID: <b>${userId}</b></p>
          <p>Proceeding to ${teamType} Registration</p>
        `,
          customClass: {
            popup: "swal-popup-custom"
          },
          timer: 4000,
          showConfirmButton: true,
        });

        // 🔀 Navigate
        handleNavigation(teamType, userId);
        window.scrollTo(0, 0);
      }
      // ❌ Failure
      else {
        Swal.fire({
          icon: "error",
          title: "❌ Registration Failed",
          text: data.error || "Unknown error occurred.",
        });
      }
    }
    // 🚨 Catch Block
    catch (err) {
      console.error("Error submitting registration:", err);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "🚨 Server Error",
        text: "Could not connect to the server. Try again later.",
      });
    }
  };



  return (
    <div className="sportselect-outer11">
      <div className="sportselect-page11">
        {/* Header Banner */}
        <div className="sportselect-header11">
          <img
            src="/Images/cricket banner womens.png"
            alt="Sports Banner"
            className="sportselect-banner11"
          />
        </div>
        <div className="sportselect-top11">
          <h2 className="sportselect-heading11">
            ATPL WOMEN’S T-20 CHAMPIONSHIP

          </h2>


          <p className="sportselect-subheading11">Register your team today to confirm entry and secure a spot in the exciting upcoming tournament.</p>

          {/* Dropdown inline with label */}
          <div className="sportselect11">


          </div>

          <div className="sportselect-row2311">
            <label className="sportselect-label11">Participation Type :</label>
            <select
              value={teamType}
              onChange={(e) => setTeamType(e.target.value)}
              className="sportselect-dropdown11"
            >
              <option value="">-- Select --</option>
              <option value="Individual">Individual</option>
              <option value="Team">Team</option>
            </select>
          </div>


          {/* Agreement section */}
          <div className="sportselect-agreement11">
            <h3>Terms & Conditions</h3>
            <ul>
              <li>All players must arrive at least 15 minutes before the match starts.</li>
              <li>Proper sports attire is mandatory during the tournament.</li>
              <li>Decisions made by referees/officials are final and must be respected.</li>
              <li>Any misconduct, abusive language, or unfair play may result in disqualification.</li>
              <li>The organizers are not responsible for personal injuries or loss of belongings.</li>
              <li>By registering, you confirm that you are physically fit to participate.</li>
            </ul>

            <p>
              The tournament committee reserves the right to modify the schedule or
              format of matches in case of unforeseen circumstances, such as weather
              conditions or venue availability. Players are expected to stay updated
              through official communication channels.
            </p>
            <p>
              All participants are expected to uphold the spirit of sportsmanship and
              camaraderie throughout the event. Any disputes or grievances should be
              reported directly to the organizing committee, whose decision will be
              considered final and binding.
            </p>

            <p>
              By joining this event, you acknowledge that participation is entirely
              voluntary and at your own risk. You also grant permission to the
              organizers to use photos or videos captured during the event for
              promotional purposes without any compensation.
            </p>

            <div className="sportselect-agreecheck11">
              <input
                type="checkbox"
                id="terms"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              <label htmlFor="terms" >
                I have read and accept the Terms & Conditions
              </label>
            </div>
          </div>

          {/* Proceed Button */}

          <div className="sportselect-btn-container11">
            <button
              className="sportselect-back-button11"
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 0);
              }}
            >
              Back
            </button>

            <button
              className="sportselect-button11"
              onClick={handleProceed}
              disabled={loading}
            >
              {loading ? "Processing..." : "Proceed"}
            </button>

          </div>

        </div>
      </div>
    </div>
  );
}
